import { getAppData } from '../../lib/api/common';
import {
	getEvents,
	getEventsPage,
	getEventCount
} from '../../lib/api/events';

import { revalidateSeconds } from "../../lib/helpers/revalidateSeconds";

import Layout from '../../components/layout/Layout';
import SeoMaticHead from '../../components/common/SeoMaticHead'
import EventsList from '../../components/content/EventsList';
import PageHeader from '../../components/content/page/PageHeader';
import EventPagination from '../../components/content/EventPagination';
import Page from '../../components/content/page/Page'

export type DealsProps = {
	app: any 				// Global site data
	page: any 				// Page header and SEO data
	updatesPage: any 		// Updates page used in breadcrumb
	events: Array<any> 		// Upcoming events
	currentPage: number 	// Current page number
	totalPages: number 		// Total number of pages for pagination
}


export async function getStaticProps(context: any) {

	const itemsPerPage: number = 8;

	const app: any = await getAppData();
	const data: any = await getEventsPage(
		context.preview ? context.previewData?.token : undefined
	);
	const events: any = await getEvents( itemsPerPage );
	const entryCount: any = await getEventCount();

	// Prepare pagination data
	const totalEntries: number = entryCount?.entryCount ? entryCount.entryCount : 0;
	const totalPages: number = Math.ceil(totalEntries / itemsPerPage);

	return {
		props: {
			app: app ? app : null,
			page: data ? data.page : null,
			updatesPage: data ? data.updatesPage : null,
			events: events?.entries ? events.entries : null,
			totalPages: totalPages,
			currentPage: 1,
		},
		revalidate: revalidateSeconds()
	};
}



export default function Deals(props: DealsProps) {

	const { page, updatesPage, events, app, currentPage, totalPages } = props

	// console.log('Events page props: ', props)

	// Breadcrumbs
	const breadcrumbs = [
		{
			id: updatesPage.id,
			title: updatesPage.title,
			uri: updatesPage.uri,
		},
		{
			id: page.id,
			title: page.title,
			uri: null,
		}
	]

	return (
		<>
			<SeoMaticHead seo={page.seo} />
			<Layout
				appData={app}
				subHeader={breadcrumbs}
			>
				<>
					<Page page={page} />

					{/* <PageHeader page={page} />
					<EventsList events={events} />
					<EventPagination currentPage={currentPage} totalPages={totalPages} /> */}
				</>
			</Layout>
		</>
	)
}
